<!-- <p>custom-dashboard-slides works!</p> -->
<div class="main_Slides_Wrapper dashboard_Main_Slides_Wrapper">
  @for (item of mergedObject1; track item; let i = $index) {
    <a class="dashanchor slides_Cards" [routerLink]="mergedObject1[i].urlLink"  [ngClass]="rbavalue?.RBAPermissions==true && rbavalue?.hasAllLocationNotNone==false && mergedObject1[i]?.h2content == 'Your Orders'? 'card_Disabled': (rbavalue?.RBAPermissions==true && rbavalue?.hasManageFin==false && mergedObject1[i]?.h2content == 'Your Financials' ? 'card_Disabled': '')">
      <img [src]="getImage(mergedObject1[i].media)" class="cards_Img" [alt]="mergedObject1[i].altText">
      <div class="card_Content">
        <p class="card_Header">{{mergedObject1[i]?.h2content}}</p>
        <p class="card_Text">{{mergedObject1[i]?.h3content}}</p>
      </div>
      <div class="arrow_Icon">
        <span [innerHTML]="mergedObject1[i].content"></span>
      </div>
      <div class="custom_Tooltip">
        <span>{{mergedObject1[i]?.largeparagraphcontent}}</span>
      </div>
    </a>
    @if (mergedObject1[i]?.h2content == 'Your Orders' || mergedObject1[i]?.h2content == 'Your Financials') {
      <div class="dashboarddiv slides_Cards" [ngClass]="rbavalue?.RBAPermissions==true && rbavalue?.hasAllLocationNotNone==true && mergedObject1[i]?.h2content == 'Your Orders'? 'card_Disabled': (rbavalue?.RBAPermissions==true && rbavalue?.hasManageFin==true && mergedObject1[i]?.h2content == 'Your Financials' ? 'card_Disabled': '')">
        <img [src]="getImage(mergedObject1[i].media)" class="cards_Img" [alt]="mergedObject1[i].altText">
        <div class="card_Content">
          <p class="card_Header">{{mergedObject1[i]?.h2content}}</p>
          <p class="card_Text">{{mergedObject1[i]?.h3content}}</p>
        </div>
        <div class="arrow_Icon">
          <span [innerHTML]="mergedObject1[i].content"></span>
        </div>
        <div class="custom_Tooltip">
          <span>{{mergedObject1[i]?.largeparagraphcontent}}</span>
        </div>
      </div>
    }
    <!--  <a  class="dashanchor" [routerLink]="mergedObject1[i].urlLink">
    <img [src]="getImage(mergedObject1[i].media)" class="cards_Img" [alt]="mergedObject1[i].altText">
    <div class="card_Content">
      <p class="card_Header">{{mergedObject1[i]?.h2content}}</p>
      <p class="card_Text">{{mergedObject1[i]?.h3content}}</p>
    </div>
    <div class="arrow_Icon">
      <span [innerHTML]="mergedObject1[i].content"></span>
    </div>
    <div class="custom_Tooltip">
      <span>{{mergedObject1[i]?.largeparagraphcontent}}</span>
      <div>
      </a> -->
    }


  </div>